import React, { Component } from 'react';
import Head from 'next/head'
import { Header, Document, Footer, PageWrapper } from '../components'


class RegisterPage extends Component {
  static async getInitialProps({ props }) {
    return props
  }

  componentDidMount() {
    window.addEventListener('message', function(e) {
      if (e.data == 'scroll_top') {
        window.scrollTo(0,0)
      }
    });
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    const { organisationId, organisation, pages } = this.props
    return (
      <div className={`u-grid u-grid--basic u-grid-${organisationId}`}>
        <Head>
          <title>{`${organisation.name} | Register`}</title>
        </Head>
        <Header region={organisation.name} regionId={organisation.id} pages={pages}/>
        <div className="u-grid__main">
          <div className='embed-container'><iframe src={`https://sportilyapp.com/register/${organisationId}`} scrolling="no"></iframe></div>
        </div>
        <Footer regionId={organisation.id}/>
      </div>
    )
  }

}

export default PageWrapper(RegisterPage)
